// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'

// css
import './index.scss'

// types
export interface NotificationBarProps {
    className?: string
    text?: string
    enabled?: boolean
}

export default function NotificationBar({
    className,
    text,
    enabled = true
}: NotificationBarProps) {
    return (
        <Section
            className={clsx(
                'notification-bar',
                className,
                !enabled && 'notification-bar--disabled'
            )}
            removeMarginTop={true}
            removeMarginBottom={true}
            data-notification-bar
        >
            <div className='container'>
                <p className='body-small' dangerouslySetInnerHTML={{ __html: text || '' }} suppressHydrationWarning />
            </div>
        </Section>
    )
}